// extracted by mini-css-extract-plugin
module.exports = {"container":"WhcevhUQ","svg":"NJbyFLKb","body":"_9fvYkdwT"};